module.exports = __webpack_public_path__ + "static/animation-ewy-97a6bf4a39fa1a257aa0b2523dd1a7ce.mp4";